/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ClientInviteLogDto } from '../models/client-invite-log-dto';
import { clientWorkspaceInviteLogControlllerAcceptInvite } from '../fn/client-workspace-invite-log/client-workspace-invite-log-controlller-accept-invite';
import { ClientWorkspaceInviteLogControlllerAcceptInvite$Params } from '../fn/client-workspace-invite-log/client-workspace-invite-log-controlller-accept-invite';
import { clientWorkspaceInviteLogControlllerCancelInvite } from '../fn/client-workspace-invite-log/client-workspace-invite-log-controlller-cancel-invite';
import { ClientWorkspaceInviteLogControlllerCancelInvite$Params } from '../fn/client-workspace-invite-log/client-workspace-invite-log-controlller-cancel-invite';
import { clientWorkspaceInviteLogControlllerInviteUser } from '../fn/client-workspace-invite-log/client-workspace-invite-log-controlller-invite-user';
import { ClientWorkspaceInviteLogControlllerInviteUser$Params } from '../fn/client-workspace-invite-log/client-workspace-invite-log-controlller-invite-user';
import { clientWorkspaceInviteLogControlllerRejectInvite } from '../fn/client-workspace-invite-log/client-workspace-invite-log-controlller-reject-invite';
import { ClientWorkspaceInviteLogControlllerRejectInvite$Params } from '../fn/client-workspace-invite-log/client-workspace-invite-log-controlller-reject-invite';
import { clientWorkspaceInviteLogControlllerSearchCursor } from '../fn/client-workspace-invite-log/client-workspace-invite-log-controlller-search-cursor';
import { ClientWorkspaceInviteLogControlllerSearchCursor$Params } from '../fn/client-workspace-invite-log/client-workspace-invite-log-controlller-search-cursor';
import { clientWorkspaceInviteLogControlllerSearchOffset } from '../fn/client-workspace-invite-log/client-workspace-invite-log-controlller-search-offset';
import { ClientWorkspaceInviteLogControlllerSearchOffset$Params } from '../fn/client-workspace-invite-log/client-workspace-invite-log-controlller-search-offset';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class ClientWorkspaceInviteLogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `clientWorkspaceInviteLogControlllerSearchOffset()` */
  static readonly ClientWorkspaceInviteLogControlllerSearchOffsetPath = '/api/clientWorkspaceInviteLog/invite/search/offset';

  /**
   * 고객사 초대 내역 오프셋 기반 검색.
   *
   * 고객사 초대 내역을 오프셋 기반으로 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceInviteLogControlllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceInviteLogControlllerSearchOffset$Response(params: ClientWorkspaceInviteLogControlllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return clientWorkspaceInviteLogControlllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 초대 내역 오프셋 기반 검색.
   *
   * 고객사 초대 내역을 오프셋 기반으로 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceInviteLogControlllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceInviteLogControlllerSearchOffset(params: ClientWorkspaceInviteLogControlllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.clientWorkspaceInviteLogControlllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceInviteLogControlllerSearchCursor()` */
  static readonly ClientWorkspaceInviteLogControlllerSearchCursorPath = '/api/clientWorkspaceInviteLog/invite/search/cursor';

  /**
   * 고객사 초대 내역 커서 기반 검색.
   *
   * 고객사 초대 내역을 커서 기반으로 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceInviteLogControlllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceInviteLogControlllerSearchCursor$Response(params: ClientWorkspaceInviteLogControlllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return clientWorkspaceInviteLogControlllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 초대 내역 커서 기반 검색.
   *
   * 고객사 초대 내역을 커서 기반으로 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceInviteLogControlllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceInviteLogControlllerSearchCursor(params: ClientWorkspaceInviteLogControlllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.clientWorkspaceInviteLogControlllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceInviteLogControlllerInviteUser()` */
  static readonly ClientWorkspaceInviteLogControlllerInviteUserPath = '/api/clientWorkspaceInviteLog/{id}/invite';

  /**
   * 고객사 구성원 초대.
   *
   * 고객사 멤버를 초대합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceInviteLogControlllerInviteUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientWorkspaceInviteLogControlllerInviteUser$Response(params: ClientWorkspaceInviteLogControlllerInviteUser$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientInviteLogDto>> {
    return clientWorkspaceInviteLogControlllerInviteUser(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 구성원 초대.
   *
   * 고객사 멤버를 초대합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceInviteLogControlllerInviteUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientWorkspaceInviteLogControlllerInviteUser(params: ClientWorkspaceInviteLogControlllerInviteUser$Params, context?: HttpContext): Observable<ClientInviteLogDto> {
    return this.clientWorkspaceInviteLogControlllerInviteUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientInviteLogDto>): ClientInviteLogDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceInviteLogControlllerAcceptInvite()` */
  static readonly ClientWorkspaceInviteLogControlllerAcceptInvitePath = '/api/clientWorkspaceInviteLog/invite/{id}/accept';

  /**
   * 고객사 초대 수락.
   *
   * 고객사 초대를 수락합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceInviteLogControlllerAcceptInvite()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceInviteLogControlllerAcceptInvite$Response(params: ClientWorkspaceInviteLogControlllerAcceptInvite$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return clientWorkspaceInviteLogControlllerAcceptInvite(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 초대 수락.
   *
   * 고객사 초대를 수락합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceInviteLogControlllerAcceptInvite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceInviteLogControlllerAcceptInvite(params: ClientWorkspaceInviteLogControlllerAcceptInvite$Params, context?: HttpContext): Observable<void> {
    return this.clientWorkspaceInviteLogControlllerAcceptInvite$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceInviteLogControlllerRejectInvite()` */
  static readonly ClientWorkspaceInviteLogControlllerRejectInvitePath = '/api/clientWorkspaceInviteLog/invite/{id}/reject';

  /**
   * 고객사 초대 거절.
   *
   * 고객사 초대를 거절합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceInviteLogControlllerRejectInvite()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceInviteLogControlllerRejectInvite$Response(params: ClientWorkspaceInviteLogControlllerRejectInvite$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return clientWorkspaceInviteLogControlllerRejectInvite(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 초대 거절.
   *
   * 고객사 초대를 거절합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceInviteLogControlllerRejectInvite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceInviteLogControlllerRejectInvite(params: ClientWorkspaceInviteLogControlllerRejectInvite$Params, context?: HttpContext): Observable<void> {
    return this.clientWorkspaceInviteLogControlllerRejectInvite$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceInviteLogControlllerCancelInvite()` */
  static readonly ClientWorkspaceInviteLogControlllerCancelInvitePath = '/api/clientWorkspaceInviteLog/{id}/invite/{inviteId}/cancel';

  /**
   * 고객사 초대 취소.
   *
   * 고객사 초대를 취소합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceInviteLogControlllerCancelInvite()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceInviteLogControlllerCancelInvite$Response(params: ClientWorkspaceInviteLogControlllerCancelInvite$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return clientWorkspaceInviteLogControlllerCancelInvite(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 초대 취소.
   *
   * 고객사 초대를 취소합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceInviteLogControlllerCancelInvite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceInviteLogControlllerCancelInvite(params: ClientWorkspaceInviteLogControlllerCancelInvite$Params, context?: HttpContext): Observable<void> {
    return this.clientWorkspaceInviteLogControlllerCancelInvite$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
